module.exports = __webpack_public_path__ + "static/media/logo.d33a680e.png";